// extracted by mini-css-extract-plugin
export default {"avatar":"branding_avatar__XG0X8","avatarImage":"branding_avatarImage__lgcWq","avatarLogo":"branding_avatarLogo__8fqI+","avatarLogoImage":"branding_avatarLogoImage__AHdI9"};